import { fetchMainApi } from '@/api/index'

export const getAccounts = (params) => fetchMainApi('GET', '/accounts?' + new URLSearchParams(params));

export const getAccount = (id) => fetchMainApi('GET', `/accounts/${id}`);

export const getAccountOrders = (id, params) => fetchMainApi('GET', `/accounts/${id}/orders?` + new URLSearchParams(params));

export const getAccountUsers = (id, params) => fetchMainApi('GET', `/accounts/${id}/users?` + new URLSearchParams(params));

export const postAccountApprove = (id) => fetchMainApi('POST', `/accounts/${id}/approve`);

export const postAccountSuspend = (id) => fetchMainApi('POST', `/accounts/${id}/suspend`);

export const postAccountImpersonate = async (id) => fetchMainApi('POST', `/accounts/${id}/impersonate`);

export const postAccountUnimpersonate = (id) => fetchMainApi('POST', `/accounts/${id}/unimpersonate`);

export const createAccount = (data) =>
  fetchMainApi('POST', '/accounts', {
    body: JSON.stringify(data)
  })

export const getAccountNotes = async (accountId) => fetchMainApi('GET', `/accounts/${accountId}/notes`)

export const addAccountNote = (accountId, note) =>
  fetchMainApi('POST', `/accounts/${accountId}/notes`, {
    body: JSON.stringify({
      note: note
    })
  })

export const deleteAccountNote = async (accountId, noteId) => fetchMainApi('DELETE', `/accounts/${accountId}/notes/${noteId}`)

export const setManager = (AccountId, data) =>
  fetchMainApi('POST', `/accounts/${AccountId}/manager`, {
    body: JSON.stringify(data)
  })
export const getManagers = async () => fetchMainApi('GET', `/managers`)

export const deleteAccount = async (accountId) => fetchMainApi('DELETE', `/accounts/${accountId}`)

export const restoreAccount = async (accountId) => fetchMainApi('POST', `/accounts/${accountId}/restore`)

// Account-locations
export const getAccountLocations = async () => fetchMainApi('GET', `/account-locations`)

export const deleteAccountLocations = async (locationId) => fetchMainApi('DELETE', `/account-locations/${locationId}`)

export const addAccountLocations = (data) =>
  fetchMainApi('POST', `/account-locations`, {
    body: JSON.stringify(data)
  })

export const updateAccountLocations = (locationId, data) =>
  fetchMainApi('PUT', `/account-locations/${locationId}`, {
    body: JSON.stringify(data)
  })

// Account-contacts
export const getAccountContacts = async (params) => {
  const queryString = params ? '?' + new URLSearchParams(params) : '';
  return fetchMainApi('GET', `/account-contacts${queryString}`);
}

export const deleteAccountContacts = async (contactId) =>
  fetchMainApi('DELETE', `/account-contacts/${contactId}`)

export const addAccountContacts = (data) =>
  fetchMainApi('POST', `/account-contacts`, {
    body: JSON.stringify(data)
  })

export const updateAccountContacts = (contactId, data) =>
  fetchMainApi('PUT', `/account-contacts/${contactId}`, {
    body: JSON.stringify(data)
  })
